module.exports = __webpack_public_path__ + "static/media/4.ad0c85fa.png";